// extracted by mini-css-extract-plugin
module.exports = {"avobj":"AvailableObjects_avobj__3BZQC","meals-appear":"AvailableObjects_meals-appear__3BCjy"};